import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import FormRunner from "@/components/timesheet/form/FormRunner";

const newKey = () => (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
const msgOf = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : d?.msg || (e?.response ? "Couldn't save your timesheet. Please try again." : "No connection. Check your signal and tap Submit again.");
};

export default function TimesheetFormPage() {
  const { token } = useParams();
  const [cfg, setCfg] = useState(null);
  const [err, setErr] = useState("");
  const key = useRef(newKey());

  useEffect(() => {
    document.title = "Timesheet · Friedman Group";
    axios.get(`${API}/public/timesheet/form`, { params: token ? { t: token } : {} })
      .then(({ data }) => setCfg(data))
      .catch((e) => setErr(msgOf(e)));
  }, [token]);

  const submit = async (answers, confirm_duplicate) => {
    try {
      const { data } = await axios.post(`${API}/public/timesheet/submit`, { answers, token: token || null, idempotency_key: key.current, confirm_duplicate });
      key.current = newKey();
      return data;
    } catch (e) {
      if (e?.response?.status === 409 && e.response.data?.detail?.code === "duplicate") return { duplicate: true, msg: e.response.data.detail.msg };
      throw new Error(msgOf(e));
    }
  };

  if (err) return <div className="min-h-[100dvh] flex items-center justify-center bg-[#F7F8FA] px-6 text-center text-slate-600" data-testid="tsf-load-error">{err}</div>;
  if (!cfg) return <div className="min-h-[100dvh] flex items-center justify-center bg-[#F7F8FA] text-sm text-slate-400" data-testid="tsf-loading">Loading…</div>;
  return <FormRunner schema={cfg.schema} employees={cfg.employees} jobs={cfg.jobs} lockedEmployee={cfg.employee} onSubmit={submit} />;
}
